export default __webpack_public_path__ + "static/media/Icon-next.e7e24465.svg";